import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { catchError, of } from 'rxjs';
import { FirebaseService } from './firebase.service';

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  private sendLogUrl = environment.serverUrl + '/client-logs/log';

  private originalConsole = {
    log: console.log,
    error: console.error,
    warn: console.warn,
    info: console.info,
  };

  constructor(
    private http: HttpClient,
    private firebaseService: FirebaseService
  ) {
    if (environment.sendLogs) {
      this.overrideConsole();
    }
  }

  private overrideConsole() {
    console.log = this.log.bind(this);
    console.error = this.error.bind(this);
    console.warn = this.error.bind(this);
    console.info = this.error.bind(this);
  }

  private log(...args: any[]) {
    if (!args) return;
    if (!environment.production) {
      this.originalConsole.log.apply(console, args);
    }
    this.sendLog(args);
  }

  private error(...args: any[]) {
    try {
      if (!args) return;
      if (!environment.production) {
        this.originalConsole.error.apply(console, args);
      }
      this.sendLog(args, true);
    } catch (err) {
      // muffle error
    }
  }

  private sendLog(args: any[], isError: boolean = false) {
    const message = this.buildLogMessage(...args);
    this.firebaseService.idToken().subscribe({
      next: (token) => {
        this.http
          .post(
            this.sendLogUrl,
            { message, is_error: isError },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .pipe(catchError((err) => of(err)))
          .subscribe({
            error: (err) => {
              // console.error('error sending log: ', err);
            },
          });
      },
      error: (err) => {
        // console.error('Error getting ID token: ', err);
        this.http
          .post(this.sendLogUrl, { message, is_error: isError })
          .pipe(catchError((err) => of(err)))
          .subscribe({
            error: (err) => {
              // console.error('error sending log: ', err);
            },
          });
      },
    });
  }

  private buildLogMessage(...args: any[]) {
    let message = '';
    for (const arg of args) {
      if (typeof arg === 'string') {
        message += arg;
      } else if (typeof arg === 'object') {
        message += JSON.stringify(arg);
      } else {
        message += arg;
      }
    }
    return message;
  }
}
